import { render } from "./ParticleBackground.vue?vue&type=template&id=0ed5dcd4&scoped=true"
import script from "./ParticleBackground.vue?vue&type=script&lang=js"
export * from "./ParticleBackground.vue?vue&type=script&lang=js"

import "./ParticleBackground.vue?vue&type=style&index=0&id=0ed5dcd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed5dcd4"]])

export default __exports__